import {onFind} from "@elements/init-modules-in-scope";
import {closest, findIn, trigger, on, removeClass, addClass} from "@elements/dom-utils";

const defaultSelectors = {
    base: '.js-file-input',
    input: '.js-file-input__input',
};

export function init(selectors = defaultSelectors) {
    onFind(selectors.base, function (base) {
        createInputText(
            base,
            {...defaultSelectors, ...selectors}
        );
    });
}

export function createInputText(base, selectors = defaultSelectors) {

    on('change', function() {
        handleChange(base);
    }, base);


    function handleChange(base) {
        let formGroup  = base,
            input      = findIn('[type="file"]', base),
            numFiles    = input.files ? input.files.length : 1,
            labelText       = input.value.replace(/\\/g, '/').replace(/.*\//, ''),
            img = findIn(selectors.img, base);



        if(numFiles >= 1) {
            addClass('has-value', input);
            addClass('has-value', formGroup);
        }

        if (numFiles === 0) {
            removeClass('has-value', input);
            removeClass('has-value', formGroup);
        }


    }
}
